export const READING_POSITION_KEY = 'bible-reading-position-v1';
export const READING_POSITION_EVENT = 'bible-reading-position-changed';

export function readReadingPosition() {
  try {
    const value = JSON.parse(localStorage.getItem(READING_POSITION_KEY));
    if (!value || !/^[a-z0-9-]+$/.test(value.section)
      || !['norm', 'ruby', 'en', 'gal', 'hebrew', 'greek'].includes(value.type)
      || !Number.isSafeInteger(value.chapter) || value.chapter < 1
      || !Number.isSafeInteger(value.verse) || value.verse < 1
      || typeof value.bookName !== 'string') return null;
    return value;
  } catch {
    return null;
  }
}

export function saveReadingPosition(value) {
  try {
    localStorage.setItem(READING_POSITION_KEY, JSON.stringify(value));
    window.dispatchEvent(new Event(READING_POSITION_EVENT));
  } catch {
    // Reading remains available when browser storage is unavailable.
  }
}

export function readingPositionUrl(value) {
  return `/bible/${value.section}?type=${value.type}#resume=${value.chapter}-${value.verse}`;
}
